import React from "react";

const AboutThisOffer = ({ offer }) => {
	return (
		<div className="p-3 text-left shop-box m-3">
			<div className="pb-2">
				<h5>About this offer</h5>
			</div>

			<div className="description-color">
				<p>{offer?.description}</p>
			</div>

			<div className="description-color">
				<p style={{ whiteSpace: "pre-line" }}>
					{offer?.offerLongDetails}
				</p>
			</div>

			<div className="description-color">
				<span>T&C: </span>
				<ul>
					{offer?.terms?.map((item, index) => (
						<li key={index}>{item}</li>
					))}
				</ul>
			</div>

			<div className="d-flex justify-content-around pt-2">
				<div>
					<a
						href={offer?.instagramLink}
						target="_blank"
						rel="noopener noreferrer"
						className="offer-details-social-btn"
					>
						<i className="fab fa-instagram"></i>
					</a>
				</div>

				<div>
					<a
						href={`https://wa.me/91${offer?.shopPhone}?text=Hello%20I%20need%20support`}
						target="_blank"
						rel="noopener noreferrer"
						className="offer-details-social-btn"
					>
						<i className="fab fa-whatsapp"></i>
					</a>
				</div>
			</div>
		</div>
	);
};

export default AboutThisOffer;
